<mat-toolbar>
  <mat-toolbar-row class="game-banner-toolbar">
    <div>
      <button mat-icon-button (click)="onSideNavToggle()" data-testid="sidenav-button">
        <mat-icon [matBadge]="(assignedSupportRequestsCount$ | async)?.length"
                  matBadgeColor="warn"
                  [matBadgeHidden]="(assignedSupportRequestsCount$ | async)?.length == 0 || (sideNavState$ | async)"
                  aria-hidden="false">
          menu
        </mat-icon>
      </button>
    </div>

    @if (currentEnvironment) {
      <span class="env-banner margin-right-large"
            data-testid="game-banner-current-environment">{{ currentEnvironment }}</span>
    }

    <h2 data-testid="no-game-header">Causable Admin App</h2>
    <app-scope-switcher class="margin-left-large"></app-scope-switcher>
    <span class="example-spacer"></span>
    <button mat-icon-button
            matTooltip="Report Field Glossary"
            (click)="openGlossary()"
            class="glossary-button"
            data-testid="global-glossary-button">
      <mat-icon>menu_book</mat-icon>
    </button>
  </mat-toolbar-row>


</mat-toolbar>
